<template>
    <div class="there-are-teams">
        <img class="header-image" src="../../assets/images/winterGame/squirrel-cup-header.png" alt="" />
        <div class="card">
            <div class="card-li">
                <div class="flex-space-between race-schedule">
                    <div class="fa today">今日赛程</div>
                    <template v-if="isNewDate ? true : false">
                        <template v-if="battleData.leg_name != '休赛日' || !battleData">
                            <div class="team">
                                {{ battleData.schedule_tag_name || '' }}
                            </div>
                        </template>
                    </template>

                    <div class="fa see" @click="handleLiveBroadcast">查看赛况直播间></div>
                </div>
                <div class="several-rounds" v-if="!isNewDate">休赛日</div>
                <template v-else>
                    <div class="several-rounds">
                        <template v-if="battleData.leg_name == '休赛日' || !battleData">
                            休赛日
                        </template>
                        <template v-else>
                            <div class="flex-vertically-center enter"
                                v-if="battleData.startEnter && battleData.startEed">
                                {{ battleData.startEnter }}
                                <img class="arrow" src="../../assets/images/winterGame/shuffle-arrow.png" />
                                {{ battleData.startEed }}
                            </div>
                            <template v-else>
                                <span v-if="battleData.boosterRace != -1">{{ battleData.leg_name }}</span>
                                <template v-else>
                                    <div v-if="battleData.round_name">
                                       第
                                        <span class="enter" style="padding: 0 10px">
                                            {{ battleData.round_name || '0' }}
                                        </span>
                                        轮
                                    </div>
                                    <div v-else>{{ battleData.leg_name }}</div>
                                </template>
                            </template>
                        </template>
                    </div>
                    <div class="time" v-if="battleData.isOffDay">{{ battleData.itmeStart }}</div>
                    <div class="time" v-else>
                        <span v-if="battleData.itmeStart">
                            {{ battleData.itmeStart }}-{{ battleData.timeEnd }}
                        </span>
                    </div>
                </template>
            </div>
        </div>
        <div class="flex-space-between entrance" v-if="todaySituation.status == 1">
            <div class="item-app" v-for="(item, index) in entrance" :key="index" @click="handleSelectTeam(index)">
                <img class="icon" :src="item.img" alt="" />
                <div class="name">{{ item.name }}</div>
            </div>
        </div>
        <div class="todays-record">
            <div class="flex-space-around tabs">
                <div class="item-tab" :class="tabsIndex === index ? 'active' : 'reversal'" v-for="(tab, index) in tabs"
                    :key="index" @click="handleTabs(index)">
                    {{ tab }}
                </div>
            </div>
            <div class="record-con">
                <div class="li-record">
                    <template>
                        <!-- 无战队代理商 -->
                        <template v-if="todaySituation.status == 2">
                            <div class="title">
                                <div class="flex-vertically-center todays-time" v-if="tabsIndex == 1">
                                    {{ today_date || '' }}
                                    <img class="calendar" src="../../assets/images/winterGame/calendar.png"
                                        @click="handleCalendarOpen">
                                </div>
                            </div>
                            <div class="todays-off-day"
                                v-if="(battleData.leg_name == '休赛日' && tabsIndex == 0) || (todaySituation.is_xiu_sai_ri == 1 && tabsIndex == 1)">
                                休赛日</div>
                            <div class="flex-space-around no-team" v-else>
                                <div class="run">
                                    <div class="num">{{ todaySituation.person_join_num || 0 }}</div>
                                    <div class="name">PK的人数</div>
                                </div>
                                <div class="run">
                                    <div class="num">{{ todaySituation.person_pk_count || 0 }}</div>
                                    <div class="name">PK的局数</div>
                                </div>
                                <div class="run">
                                    <div class="num">{{ todaySituation.person_win_count || 0 }}</div>
                                    <div class="name">胜利局数</div>
                                </div>
                            </div>

                        </template>
                        <!-- 有战队代理商 -->
                        <template v-else>
                            <!-- <template v-if="todaySituation.time_type == '2-1' || todaySituation.time_type == '2-2'"> -->
                            <!-- 优先展示晋级 和 助力 -->
                            <template v-if="tabsIndex == 0 && isShowView == 1 && !isNewDate">
                                <div class="title">
                                    <div class="name">{{ todaySituation.team_name || '' }}</div>
                                    <div class="small-team">
                                        {{ todaySituation.group_name || '' }}
                                    </div>
                                </div>
                                <!--小组赛  ----  是否晋级 -->
                                <div class="special-sharing fucking-great" v-if="todaySituation.time_type == '2-1'">
                                    <div class="promotion-display">
                                        <!-- 已晋级 -->
                                        <img class="pic" src="../../assets/images/winterGame/fucking-great.png" alt="">
                                        <div class="group-ranking">小组第{{ todaySituation.rank }}名</div>
                                        <!-- 松鼠杯冬季赛冠军 -->
                                    </div>
                                    <div class="special-sharing"
                                        v-if="tabsIndex == 0 && todaySituation.time_type == '2-1'">
                                        <div class="time">淘汰赛开赛时间：{{ todaySituation.knockout_date }}</div>
                                        <div class="flex-vertically-center share-btn special"
                                            @click="handlePosterSharing(4, todaySituation)">
                                            <img class="share" src="../../assets/images/winterGame/share.png" />
                                            查看海报
                                        </div>
                                    </div>
                                </div>
                                <!--淘汰赛  ----  是否晋级 -->
                                <div class="special-sharing fucking-great"
                                    v-if="(todaySituation.time_type == '3-1')">
                                    <div class="promotion-display">
                                        <!-- 已晋级 -->
                                        <template v-if="todaySituation.promotion">
                                            <img class="pic" src="../../assets/images/winterGame/fucking-great.png"
                                                alt="">
                                            <div class="group-ranking">{{ todaySituation.war_zone }}{{ todaySituation.sectionName }}</div>
                                        </template>
                                        <!-- 淘汰赛-8强 || 4强 -->
                                        <template v-else>
                                            <img class="pic" src="../../assets/images/winterGame/knockout.png" alt="">
                                            <div class="strong-box">
                                                <div class="strong">{{ todaySituation.sectionName || '' }}</div>
                                                <div class="war-zone">{{ todaySituation.war_zone || '' }}</div>
                                            </div>
                                        </template>
                                    </div>
                                    <template v-if="todaySituation.time_type == '3-1'">
                                        <performanceData :todaySituation="todaySituation" />
                                    </template>
                                </div>
                                <!-- 助力 -->
                                <template v-if="todaySituation.time_type == '2-2'">
                                    <div class="help-rank">
                                        <div class="flex-vertically-center num">
                                            <img class="icon" src="../../assets/images/winterGame/flames1.png" />
                                            {{ todaySituation.supports_num || 0 }}
                                        </div>
                                        <div class="support">支持数</div>
                                        <div class="not-yet"><span>{{ todaySituation.war_zone || '' }}</span>排名：{{ todaySituation.rank || 0 }}</div>
                                        <!-- <div class="not-yet" v-if="todaySituation.rank - 4 > 0">
                                            还差{{ todaySituation.rank - 4 }}可复活
                                        </div> -->
                                        <div class="fucking-great">
                                            <div class="special-sharing">
                                                <div class="flex-vertically-center share-btn special"
                                                    @click="handlePosterSharing(5, todaySituation)">
                                                    <img class="share" src="../../assets/images/winterGame/share.png" />
                                                    邀请助力
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </template>
                            <template class="todays-off-day" v-else>
                                <template
                                    v-if="(tabsIndex == 0 && isNewDate && (battleData.leg_name == '休赛日' || !battleData)) || (tabsIndex == 1 && todaySituation.is_xiu_sai_ri == 1)">
                                    <div class="todays-off-day">
                                        今日休赛日
                                    </div>
                                </template>
                                <template v-else>
                                   <template v-if="(todaySituation.time_type == '3-0') ? false : true">
                                    <img class="rank-first" src="../../assets/images/winterGame/rank-first.png"
                                        v-show="(tabsIndex === 1 && todaySituation.rank == 1)" />
                                    <div class="title">
                                        <div class="flex-vertically-center todays-time" v-if="tabsIndex == 1">
                                            {{ today_date || '' }}
                                            <img class="calendar" src="../../assets/images/winterGame/calendar.png"
                                                @click="handleCalendarOpen" />
                                        </div>
                                        <!-- (battleData.leg_name == '休赛日' || !battleData) || -->
                                        <template v-if="(todaySituation.is_xiu_sai_ri == 1) ? false : true">
                                            <div class="name">{{ todaySituation.team_name || '' }}</div>
                                           <template v-if="tabsIndex == 0">
                                                <template v-if="todaySituation.time_type== '3-1' || todaySituation.time_type== '3-2'">
                                                    <div class="small-team">
                                                        {{ todaySituation.tag || '' }}
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="small-team" v-if="todaySituation.time_type != '2-2'">
                                                        {{ todaySituation.group_name || '' }}
                                                    </div>
                                                </template>
                                           </template>
                                        </template>
                                    </div>
                                   </template>
                                    <!--小组赛  ----  是否晋级 -->
                                    <div class="special-sharing fucking-great"
                                        v-if="todaySituation.time_type == '2-1'">
                                        <div class="promotion-display">
                                            <!-- 已晋级 -->
                                            <img class="pic" src="../../assets/images/winterGame/fucking-great.png" />
                                            <div class="group-ranking">小组第{{ todaySituation.rank }}名</div>
                                        </div>
                                        <div class="special-sharing"
                                            v-if="tabsIndex == 0 && todaySituation.time_type == '2-1'">
                                            <div class="time">淘汰赛开赛时间：{{ todaySituation.knockout_date }}</div>
                                        </div>
                                    </div>
                                    <!--淘汰赛  ----  是否晋级 -->
                                    <div class="special-sharing fucking-great" v-if="todaySituation.time_type == '3-1' || todaySituation.time_type == '3-2'">
                                        <div class="promotion-display" >
                                            <!-- 已晋级 -->
                                            <template v-if="todaySituation.promotion">

                                                <img class="pic" src="../../assets/images/winterGame/fucking-great.png" />
                                                <div class="group-ranking">
                                                    <template v-if="tabsIndex == 1">
                                                       <span v-if="((todaySituation.tag == '8进4' || todaySituation.tag =='决赛')) ? false : true">{{todaySituation.war_zone}}</span>{{ todaySituation.sectionName || ''}}
                                                    </template>
                                                    <span v-if="tabsIndex == 0"> {{ todaySituation.sectionName == '决赛' ? '全国冠军' : todaySituation.tag }}</span>
                                                </div>

                                            </template>
                                            <!-- 淘汰赛-8强 || 4强 -->
                                            <template v-else>
                                                    <div class="not-promoted" v-if="todaySituation.time_type == '3-2'">未晋级</div>
                                                    <img class="pic" src="../../assets/images/winterGame/knockout.png" />
                                                    <div class="strong-box">
                                                        <template v-if="todaySituation.winterGames"><span class="strong">全国8强</span></template>
                                                        <div class="strong" v-if="!todaySituation.winterGames">{{ todaySituation.sectionName || '' }}</div>
                                                        <div class="war-zone"  v-if="todaySituation.tag == '8进4' || todaySituation.tag == '决赛'" >松鼠杯</div>
                                                        <div v-else>
                                                            <template v-if="todaySituation.winterGames"><span class="war-zone">松鼠杯</span></template>
                                                             <template v-else>
                                                                <span class="war-zone" v-if="todaySituation.sectionName == '决赛'">全国冠军</span>
                                                                <span class="war-zone" v-if="todaySituation.sectionName == '半决赛'">{{ todaySituation.tag || '' }}</span>
                                                                <template v-if="tabsIndex ===0 ">
                                                                    <span v-if="(todaySituation.sectionName == '决赛' || todaySituation.sectionName == '半决赛') ? false : true"> {{ todaySituation.war_zone || ''}}</span>
                                                                </template>
                                                                <template v-if="tabsIndex === 1 ">
                                                                    <span class="war-zone" v-if="(todaySituation.sectionName == '冠军' || todaySituation.sectionName == '全国冠军')"> 松鼠杯</span>
                                                                    <span class="war-zone" v-else>{{ todaySituation.war_zone || ''}}</span>
                                                                </template>
                                                             </template>
                                                        </div>
                                                    </div>
                                            </template>
                                        </div>
                                        <!-- <template v-if="todaySituation.time_type == '3-1'">
                                            <performanceData :todaySituation="todaySituation" />
                                        </template> -->
                                    </div>

                                    <!-- 页面展示数据   || todaySituation.time_type == 1 || todaySituation.time_type == '3-1'-->
                                    <template
                                        v-if="(!todaySituation.time_type || todaySituation.time_type == 1 || (tabsIndex == 1 && todaySituation.time_type == '2-1') || todaySituation.time_type == '3-1')">
                                        <performanceData :todaySituation="todaySituation" />
                                    </template>
                                    <div class="todays-off-day" v-if="todaySituation.time_type == '3-0'"> 未晋级 </div>

                                    <!-- 助力 -->
                                    <template
                                        v-if="todaySituation.time_type == '2-2'">
                                        <div class="help-rank">
                                            <div class="flex-vertically-center num">
                                                <img class="icon" src="../../assets/images/winterGame/flames1.png" />
                                                {{ todaySituation.supports_num || 0 }}
                                            </div>
                                            <div class="support">支持数</div>
                                            <div class="not-yet"><span>{{ todaySituation.war_zone || '' }}</span>排名：{{ todaySituation.rank || 0 }}</div>
                                            <!-- <div class="not-yet" v-if="todaySituation.rank - 4 > 0">
                                                还差{{ todaySituation.rank - 4 }}可复活
                                            </div> -->
                                            <div class="fucking-great">
                                                <div class="special-sharing">
                                                    <div class="flex-vertically-center share-btn special"
                                                        @click="handlePosterSharing(5, todaySituation)">
                                                        <img class="share"
                                                            src="../../assets/images/winterGame/share.png" />
                                                        邀请助力
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <!-- 战绩普通分享 -->
                                    <template
                                        v-if="(tabsIndex == 1 && todaySituation.rank != 1 && (todaySituation.is_xiu_sai_ri == 0 && todaySituation.time_type == 1))">
                                        <div class="fucking-great">
                                            <div class="special-sharing">
                                                <div class="flex-vertically-center share-btn"
                                                    @click="handlePosterSharing(1, todaySituation)">
                                                    <img class="share" src="../../assets/images/winterGame/share.png" />
                                                    查看海报
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <!-- 昨日战绩-是否晋级分享-2 && -->
                                    <template v-if="(tabsIndex == 0 && todaySituation.time_type == '2-1') ||  (todaySituation.time_type == '2-1' || todaySituation.time_type == '3-1' || todaySituation.time_type == '3-2')">
                                        <div class="fucking-great" >
                                            <div class="special-sharing">
                                                <div class="flex-vertically-center share-btn special"
                                                    @click="handlePosterSharing(4, todaySituation)">
                                                    <img class="share" src="../../assets/images/winterGame/share.png" />
                                                    查看海报
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <!-- 昨日战绩---全网第一分享 -->
                                    <template v-if="todaySituation.is_xiu_sai_ri == 0">
                                        <div class="fucking-great" v-if="tabsIndex == 1 && todaySituation.rank == 1">
                                            <div class="special-sharing">
                                                <div class="flex-vertically-center share-btn special"
                                                    @click="handlePosterSharing(3, todaySituation)">
                                                    <img class="share" src="../../assets/images/winterGame/share.png" />
                                                    查看海报
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                            </template>

                            <!-- </template> -->

                        </template>
                    </template>
                </div>
            </div>
            <div class="view-students" v-if="todaySituation.status == 2" @click="handleViewAllStudents">查看所有学员></div>
            <!-- userInfoId.agentId == yesterday_star.service_id -->
            <img class="sign-mvp" v-if="!isId" src="../../assets/images/winterGame/mvp.png" />
            <img class="sign-mvp" v-if="isId" src="../../assets/images/winterGame/star.png" />
            <div class="battalion">
                <div class="team-information" v-if="todaySituation.status != 2">
                    <div class="team-li">
                        <div class="flex-vertically-center title" v-if="!isId">
                            战队
                            <!-- <span class="sub-label" v-if="todaySituation.status == 2">服务中心</span> -->
                        </div>
                        <div class="title" v-else>
                            个人赛<span class="sub-label">全网</span>
                        </div>
                        <div class="flex-vertically-center single-day-trophy">
                            <img class="pic" src="../../assets/images/winterGame/line.png" alt="" />
                            <div class="most">单日奖杯数最多</div>
                        </div>
                        <div class="time">{{ teamMvp.date || '' }}</div>
                        <div class="name">{{ teamMvp.real_name || '' }}</div>
                        <div class="flex-space-around introduce">
                            <div>
                                <div class="number">{{ teamMvp.score || 0 }}</div>
                                <div class="trophy">奖杯数</div>
                            </div>
                            <div>
                                <div class="number">{{ teamMvp.win_rate || 0 }}%</div>
                                <div class="trophy">胜率</div>
                            </div>
                        </div>
                        <div class="flex-vertically-center share-btn" :class="offDay == 1 ? 'off-day' : ''"
                            @click="handlePosterSharing(2, teamMvp, 2)">
                            <img class="share" src="../../assets/images/winterGame/share.png" />
                            查看海报
                        </div>
                    </div>
                </div>

                <template v-if="isId && todaySituation.status == 1">
                    <img class="sign-mvp" src="../../assets/images/winterGame/mvp.png" />
                </template>
                <div class="team-information">
                    <div class="team-li">
                        <div class="title" v-if="isId && todaySituation.status == 2"> 个人赛<span
                                class="sub-label">全网</span> </div>
                        <div class="title" v-if="isId"> 战队 </div>
                        <div class="title" v-else>
                            个人赛<span class="sub-label">服务中心</span>
                        </div>
                        <div class="flex-vertically-center single-day-trophy">
                            <img class="pic" src="../../assets/images/winterGame/line.png" alt="" />
                            <div class="most">单日奖杯数最多</div>
                        </div>
                        <div class="time">{{ serviceMvp.date || '' }}</div>
                        <div class="name">{{ serviceMvp.real_name || '' }}</div>
                        <div class="flex-space-around introduce">
                            <div>
                                <div class="number">{{ serviceMvp.score || 0 }}</div>
                                <div class="trophy">奖杯数</div>
                            </div>
                            <div>
                                <div class="number">{{ serviceMvp.win_rate || 0 }}%</div>
                                <div class="trophy">胜率</div>
                            </div>
                        </div>
                        <div class="flex-vertically-center share-btn" @click="handlePosterSharing(2, serviceMvp, 1)">
                            <img class="share" src="../../assets/images/winterGame/share.png" />查看海报
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 分享海报 -->
        <battalionPoster :posterUrl="posterUrl" ref="poster" :isShow="isShow" @OnCancelPoster="handleCancelPoster">
            <div id="container">
                <div class="poster-war-report">
                    <img class="bac-pic" src="../../assets/images/winterGame/poster-bac.png" v-if="isPoster == 1" />
                    <img class="bac-pic" src="../../assets/images/winterGame/poster-bac1.png" v-if="isPoster == 2" />
                    <img class="bac-pic" src="../../assets/images/winterGame/poster-bac2.png" v-if="isPoster == 3" />
                    <img class="bac-pic" src="../../assets/images/winterGame/poster-bac3.png" v-if="isPoster == 4" />
                    <img class="bac-pic" src="../../assets/images/winterGame/poster-bac4.png" v-if="isPoster == 5" />
                    <!-- ====== -->
                    <div class="poster-conter" v-if="isPoster == 1">
                        <div class="time">{{ posrerData.knockout_date || today_date || '' }}</div>
                        <div class="server-center"> {{ servicePoint.servicePointName || '' }} </div>
                        <div class="title">{{ todaySituation.team_name || '' }}</div>
                        <div class="trophy">
                            <div class="name">单日奖杯数</div>
                            <div class="num">{{ todaySituation.one_day_score || 0 }}</div>
                        </div>
                    </div>
                    <!-- ====== -->
                    <div class="most-trophies" v-if="isPoster == 2">
                        <div class="time">{{ posrerData.date || '' }}</div>
                        <div class="title">
                            <div>{{ posrerData.titleLab || '' }}</div>单日奖杯数最多
                        </div>
                        <div class="record">
                            <div class="name">{{ posrerData.real_name || '' }}</div>
                            <div class="flex-vertically-center arae">
                                <div class="exhibition">
                                    <div class="number">{{ posrerData.score || 0 }}</div>
                                    <div class="text">奖杯数</div>
                                </div>
                                <div class="exhibition">
                                    <div class="number">{{ (posrerData.win_rate || 0) }}%</div>
                                    <div class="text">胜率</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- ====== -->
                    <div class="excellent-team" v-if="isPoster == 3">
                        <div class="time">{{ posrerData.knockout_date }}</div>
                        <div class="title">全网单日奖杯数最多</div>
                        <div class="record">
                            <div class="address">{{ servicePoint.servicePointName || '' }}</div>
                            <div class="name team-name">{{ posrerData.team_name || '' }}</div>
                            <div class="flex-vertically-center arae">
                                <div class="exhibition">
                                    <div class="number">{{ posrerData.score || 0 }}</div>
                                    <div class="text">奖杯数</div>
                                </div>
                                <div class="exhibition">
                                    <div class="number">{{ posrerData.win_rate || 0 }}%</div>
                                    <div class="text">胜率</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- ====== -->
                    <div class="promotion" v-if="isPoster == 4">
                        <div class="time"></div>
                        <div class="server-center">{{ servicePoint.servicePointName || '' }}</div>
                        <div class="title"> {{ todaySituation.team_name || '' }} </div>
                        <div class="trophy">
                            <div class="name">
                                {{ todaySituation.time_type == '2-1' || todaySituation.promotion ? '晋级' : (todaySituation.winterGames ? '全国' + todaySituation.sectionName : todaySituation.sectionName)  || '' }}
                            </div>
                            <div class="num" v-if="todaySituation.time_type == '2-1' && !todaySituation.promotion">
                                 {{ '小组第' + (todaySituation.rank || 0) + '名'  }}
                            </div>
                            <div class="num" v-else>
                                <div v-if="todaySituation.promotion">
                                    <template v-if="tabsIndex == 1">
                                        <span v-if="(todaySituation.tag == '8进4' || todaySituation.tag =='决赛') ? false : true">{{ todaySituation.war_zone || '' }}</span><span>{{ todaySituation.sectionName || '' }}</span>
                                    </template>
                                    <span v-if="tabsIndex == 0"> {{ todaySituation.sectionName == '决赛' ? '全国冠军' : todaySituation.tag }}</span>
                                </div>
                                <div v-else>
                                    <template v-if="(todaySituation.tag == '8进4' || todaySituation.tag =='决赛' )">松鼠杯</template>
                                    <template v-else>
                                        <span v-if="todaySituation.sectionName == '决赛'">全国冠军</span>
                                        <span v-if="todaySituation.sectionName == '半决赛'">{{ todaySituation.tag || '' }}</span>
                                        <template v-if="todaySituation.winterGames">
                                            <span>松鼠杯</span>
                                        </template>
                                        <template v-else>
                                            <span v-if="(todaySituation.sectionName == '决赛' || todaySituation.sectionName == '半决赛') ? false : true"> {{ todaySituation.war_zone || ''}}</span>
                                        </template>
                                    </template>
                                </div>

                            </div>
                            <!-- todaySituation.war_zone || '' -->
                        </div>
                    </div>
                    <!-- ====== -->
                    <div class="help-with-likes" v-if="isPoster == 5">
                        <div class="server-center">{{ servicePoint.servicePointName }}</div>
                        <div class="battalion">
                            <div class="name"> 我的战队 </div>
                            <div class="title"> {{ todaySituation.team_name }} </div>
                            <div class="introduce"> 参加松鼠杯打基础冬季赛需要你的支持！ </div>
                        </div>
                    </div>
                </div>
                <!-- 二维码 -->
                <div class="qr-code">
                    <div class="code-bac">
                        <img class="code-pic" :src="codeUrlImge" />
                    </div>
                    <div class="distinguish">
                        <template v-if="isPoster == 5">
                            <div>微信扫一扫识别二维码</div>
                            <div>支持我的战队</div>
                        </template>
                        <template v-else>
                            <div>识别二维码</div>
                            <div>参加松鼠杯</div>
                        </template>
                    </div>
                </div>
            </div>
        </battalionPoster>
        <!--  -->
        <div class="date-picker">
            <van-popup v-model="showPicker" position="bottom">
                <van-datetime-picker v-model="currentDate" type="date" :columns-order="['year', 'month', 'day',]"
                    :min-date="minDate" :max-date="maxDate" :formatter="formatter" @cancel="showPicker = false"
                    @confirm="confirmPicker" />
            </van-popup>
        </div>
        <img class="loding-icon" src="../../assets/images/winterGame/loading.png" v-if="isLoding">
    </div>
</template>
<script>
import { Toast } from "vant";
import html2canvas from "html2canvas";
import { queryAgentIndexData, agentGroupYesterdaySituation, agentPersonYesterdaySituation, queryMatchCampus, qrCode } from "../../api/winterGame";
import battalionPoster from "../../components/SquirrelCupII/battalion-poster";
import performanceData from '../../components/SquirrelCupII/performance-data.vue'
export default {
    components: { battalionPoster, performanceData },
    data() {
        return {
            entrance: [{ img: require("../../assets/images/winterGame/icon1.png"), name: "排行榜", }, { img: require("../../assets/images/winterGame/icon2.png"), name: "我的战队", }, { img: require("../../assets/images/winterGame/icon3.png"), name: "全部学员", }],
            tabs: ["今日战况", "昨日战绩"],
            codeUrl: "https://exp4pad.classba.cn/winterGame/register", // 成才二维码地址
            KnockoutFinals: {'64进32':'16强','32进16':'8强','16进8':'4强','8进4':'全国8强','半决赛':'冠军','决赛':'全国冠军'},
            posterUrl: "", // 生成海报地址
            isPoster: -1, // 海报参数
            isPromotion: 1, // 海报参数
            posrerData: {}, // 分享海报展示数据
            servicePoint: {}, //保存服务中心
            codeUrlImge: '', //生成二维码地址
            isShowView: -1,
            teamIndex: 0,
            tabsIndex: 0,
            showPicker: false,
            isNewDate: false,
            isLoding: true,
            today_date: '',
            minDate: new Date(2020, 0, 1),
            maxDate: new Date(2050, 10, 1),
            currentDate: new Date(this.FunGetYesDate()),
            offDay: 0, // 休赛日
            rankFirst: false,
            isId: false,
            isShow: false,
            OpageData: {}, //保存全部数据
            todaySituation: {}, // 获取当前展示数据
            battleData: {}, // 头部数据信息
            teamMvp: {},
            serviceMvp: {},
            yesterdayStar: {},

        };
    },
    created() {
        try {
            const { agentId, openId } = this.$route.query || {}
            let params = { agentId, openId }
            this.userInfoId = localStorage.setItem("userInfoId", JSON.stringify(params || {})) || {}
            console.log('小程序携带参数', params)
        } catch (error) {
            console.log(error)
        }
        this.FunGetYesDate()
        this.initData()
        setTimeout(() => {
            this.onRecodeImage()
        }, 600)
    },
    mounted() {
        let currentDate = new Date();
        let endTime = new Date('2023/01/26')
        this.isNewDate = currentDate > endTime
        console.log(currentDate > endTime)
        console.log(this.isNewDate)
    },
    methods: {
        // 获取昨天时间
        FunGetYesDate() {
            var myDate, myDateStr;
            myDate = new Date(new Date() - 1000 * 60 * 60 * 24);
            var yyyy = myDate.getFullYear();//取四位年份
            var MM = myDate.getMonth() + 1;//取月份
            var dd = myDate.getDate();//取日
            if (MM < 10) {
                MM = "0" + MM;
            }
            if (dd < 10) {
                dd = "0" + dd;
            }
            myDateStr = yyyy + "-" + MM + "-" + dd;
            console.log(myDateStr);
            this.today_date = myDateStr;
            return myDateStr
        },
        async initData() {
            this.userInfoId = await JSON.parse(localStorage.getItem('userInfoId')) || {};
            await this.getDataList()
            await this.getServerId()
        },
        async getServerId() {
            let params = {
                param: { campusId: this.userInfoId.agentId || 88 }
            }
            await queryMatchCampus(params).then(res => {
                if (res.code === 0) {
                    this.servicePoint = res.data || {}
                }
            })
        },
        async getDataList() {
            const { userInfoId, KnockoutFinals,  tabsIndex } = this
            let date = new Date()
            let Y = date.getFullYear();  // 获取完整的年份(4位,1970)
            let M = date.getMonth() + 1;  // 获取月份(0-11,0代表1月,用的时候记得加上1)
            let D = date.getDate();  // 获取日(1-31)
            let currentTime = Y + '/' + M + '/' + D;
            console.log(currentTime)

            let params = {
                param: { agentId: userInfoId.agentId, openId: userInfoId.openId }
            }
            await queryAgentIndexData(params).then(res => {
                if (res.code === 0) {
                    const { today_schedule, today_situation, team_mvp, service_mvp, yesterday_situation, yesterday_star } = res.data || {}
                    today_schedule && today_schedule.schedule && Array.isArray(today_schedule.schedule) && today_schedule.schedule.map(item => {
                        let leg_end = item.leg_end && (item.leg_end).replace(/\-/g, '/')
                        let leg_start = item.leg_start && (item.leg_start).replace(/\-/g, '/')
                        let date1 = new Date(leg_end);
                        let date2 = new Date(leg_start);
                        let date3 = new Date(currentTime);
                        let result = date3 >= date2 && date3 <= date1;
                        // if (result) {
                        // item.leg_name = '半决赛'
                        console.log('=--', item.leg_name.search(/好/i))
                        let leg_name = item.leg_name && (item.leg_name).split('进')
                        let timeStart = leg_start && leg_start.split('/') || []
                        let timeEnd = leg_end && leg_end.split('/') || []
                        item.boosterRace = item.leg_name && item.leg_name.search(/力/i)
                        item.round_name = item.leg_name &&  item.leg_name.includes('第') && item.leg_name.substring(1, item.leg_name.length - 1) || ''
                        item.startEnter = leg_name[0]
                        item.startEed = leg_name[1]
                        item.itmeStart = /*timeStart[0] + '年' + */ timeStart[1] + '月' + timeStart[2] + '日'
                        item.timeEnd = /*timeEnd[0] + '年' + */ timeEnd[1] + '月' + timeEnd[2] + '日'
                        // 判断休赛日---开始和结束是否在同一天
                         item.isOffDay = date1.getTime() === date2.getTime() ? true : false
                        this.battleData = item
                        // }
                    })
                    team_mvp.win_rate = Math.round(Number(team_mvp.win_rate || 0) / 100)
                    service_mvp.win_rate = Math.round(Number(service_mvp.win_rate || 0) / 100)
                    // today_situation.time_type = '3-1'
                    // today_situation.promotion = true
                    // today_situation.tag = '松鼠杯冬季赛冠军'
                    let num = today_situation.tag && (today_situation.tag).replace(/[^\d]/g, ""); // 截取数字
                    let banJueSai = today_situation.tag && (today_situation.tag).includes('区冠军')
                    let jueSai = today_situation.tag && (today_situation.tag).includes('冬季赛冠军')
                    today_situation.sectionName = num ? num + '强' : banJueSai ? '半决赛' : jueSai ? '决赛'  : today_situation.tag ;
                    today_situation.winterGames = today_situation.tag && (today_situation.tag).includes('冬季赛8强') ? '全国8强' : ''

                    console.log('--', (today_situation.tag && today_situation.tag).replace(/[^\d]/g, ""))
                    let isId = userInfoId.agentId == yesterday_star.service_id || ''
                    console.log(isId)
                    this.isId = isId
                    this.todaySituation = today_situation || {}
                    this.teamMvp = isId ? (yesterday_star || {}) : team_mvp || {}
                    // 无战队代理商数据处理
                    if (today_situation.status == 2 || yesterday_situation.status == 2) {
                        this.serviceMvp = isId ? yesterday_star || {} : service_mvp || {}
                    } else {
                        this.serviceMvp = isId ? (team_mvp || {}) : service_mvp || {}
                    }
                    console.log()
                    this.OpageData = res.data || {}
                    this.isShowView = today_situation.time_type == '2-1' || today_situation.time_type == '2-2' ? 1 : 0
                    setTimeout(() => {
                        this.isLoding = false
                    }, 500)
                }
            })
        },
        handleSelectTeam(index) {
            this.teamIndex = index;
            switch (index) {
                case 0:
                    this.$router.push("/winterGame/theGame");
                    break;
                case 1:
                    this.$router.push("/winterGame/myTeam");
                    break;
                case 2:
                    window.wx.miniProgram.navigateTo({ url: '/subpackages/home/winterGame/theGame/index' })
                    break;
            }
        },
        handleTabs(index) {
            this.tabsIndex = index;
            const { today_situation, yesterday_situation, team_mvp, service_mvp, yesterday_star } = this.OpageData
            console.log('ttt', yesterday_situation)
            // yesterday_situation.tag = '64进32'
            Object.entries(this.KnockoutFinals).map(([key, val]) =>{
                if(key == yesterday_situation.tag || ''){
                    yesterday_situation.sectionName  = val
                    console.log('------888',val)
                }
            })
            // yesterday_situation.is_xiu_sai_ri = 0
            // yesterday_situation.time_type = '3-1'
            // yesterday_situation.promotion = true

            // yesterday_situation.rank = 10
            // console.log('今日', yesterday_situation.is_xiu_sai_ri.toString())
            console.log('昨日', yesterday_situation)
            if (index === 0) {
                this.todaySituation = today_situation
            } else if (index === 1) {
                console.log('==yesterday_situation', yesterday_situation)
                this.$set(this, 'todaySituation', yesterday_situation)
            }
            this.FunGetYesDate()

        },
        // 跳转直播间
        handleLiveBroadcast() {
            let serviceId = this.userInfoId.agentId
            // let url = 'https://live-matches-h5-test.songshuai.com/#/' // 测试环境
            let url = 'https://live-matches-h5.songshuai.com/#/' // 生产环境
            window.location.href = `${url}?serviceId=${serviceId}&type=1`
        },
        handleCancelPoster(type) {
            this.isShow = type;
        },
        // 分享生成图片
        onSharePlu() {
            Toast.loading({ message: "加载中...", forbidClick: true, duration: 0 });
            setTimeout(() => {
                const targetDom = document.querySelector("#container");
                const config = {
                    useCORS: true,
                    logging: true,
                    width: targetDom.offsetWidth,
                    height: targetDom.offsetHeight - 4
                }
                html2canvas(targetDom, config).then((canvas) => {
                    this.isShow = true;
                    this.posterUrl = canvas.toDataURL();
                    console.log(this.isPoster)
                    Toast('长按保存图片');;
                    this.isPoster = -1
                });
            }, 1000)
        },
        // 分享战报
        handlePosterSharing(type, data = {}, title) {
            // type 1：战报  2:  3:全网第一  4:晋级  5: 助力
            console.log('---', title)
            let { isId } = this;
            if (type == 2) {
                if (title == 1 && isId || title == 2 && !isId) {
                    data.titleLab = '战队'
                } else if (title == 1 && !isId) {
                    data.titleLab = '个人赛（服务中心）'
                }
                if (title == 2 && isId) {
                    data.titleLab = '个人赛（全网）'
                }
            }
            if (type == 5) {
                this.onRecodeImage(5)
                // gio("track", "onShareBattleReport", { onSharePosters: "helpShare" });
            } else {
                // gio("track", "onShareBattleReport", { onSharePosters: "ShareLogo" });
            }
            console.log(data)
            this.posrerData = data
            this.isPoster = type
            this.onSharePlu()
        },
        // 生成二维码
        onRecodeImage(type) {
            const { codeUrl, userInfoId } = this || {}
            // let path = 'https://live-matches-h5-test.songshuai.com/#/like'
            let path = 'https://live-matches-h5.songshuai.com/#/like'
            const urlHb = `${codeUrl}?c=${userInfoId.agentId}&f=${userInfoId.agentUserId ? userInfoId.agentUserId : 0}&s=松鼠杯_冬季赛`;
            const urlZl = `${path}?serviceId=${userInfoId.agentId}&followUserId=${userInfoId.agentUserId || 0}`;
            const url = type == 5 ? urlZl : urlHb
            console.log(urlHb)
            const params = { param: url }
            qrCode(params).then(res => {
                if (res.code === 0) {
                    this.codeUrlImge = res.data || ''
                }
            })
        },
        // 查看所有学员
        handleViewAllStudents() {
            window.wx.miniProgram.navigateTo({ url: '/subpackages/home/winterGame/theGame/index' })
        },
        // 日期搜索
        handleCalendarOpen() {
            this.showPicker = true;
        },
        // 选择日期弹出层
        confirmPicker(time) {
            console.log(time)
            let year = time.getFullYear();
            let month = (time.getMonth() + 1) > 9 ? (time.getMonth() + 1) : '0' + (time.getMonth() + 1);
            let day = (time.getDate()) > 9 ? (time.getDate()) : '0' + (time.getDate());
            let selectedTime = year + '-' + month + '-' + day
            console.log(selectedTime)
            this.today_date = selectedTime
            this.showPicker = false;
            const { userInfoId, todaySituation, isId } = this
            let params = {
                param: {
                    agentId: userInfoId.agentId,
                    openId: userInfoId.openId,
                    date: selectedTime
                }
            }
            if (todaySituation.status == 1) {
                //小组赛搜索 - 有战队
                agentGroupYesterdaySituation(params).then(res => {
                    if (res.code === 0) {

                        let dataObj = res.data || {}
                        // dataObj.win_rate = Math.round(Number(dataObj.win_rate || 0) / 100)
                        let obj = {
                            knockout_date: selectedTime,
                            ...todaySituation,
                            status: 1,
                            // time_type: 1 ,// todaySituation.time_type,
                            ...dataObj
                        }
                        // res.data = null
                        console.log('res', res)
                        this.todaySituation = dataObj && obj || {}
                    } else {
                        Toast.error(res.message || '搜索失败')
                    }
                })
            } else if (todaySituation.status == 2) {
                // 个人赛搜索 - 没有战队
                agentPersonYesterdaySituation(params).then(res => {
                    if (res.code === 0 && res.data) {
                        this.todaySituation = { status: 2, ...res.data } || {}
                    }
                })
            }


        },
        formatter(type, value) {
            if (type === 'year') {
                return value + '年'
            } else if (type === 'month') {
                return value + '月'
            } else if (type === 'day') {
                return value + '日'
            }
            return value
        }
    },
};
</script>
<style lang="less" >
@import "../../assets/style/global.less";

.not-promoted {
    font-size: 22px;
    font-weight: 400;
    color: #68707D;
    text-align: center;
    position: relative;
    margin-bottom: -50px;
    padding-top: 20px;
}

/**  日期样式 */
.date-picker {
    .van-popup {
        border-top-left-radius: 32px;
        border-top-right-radius: 32px;

        .van-datetime-picker {

            .van-picker__cancel,
            .van-picker__confirm {
                font-size: 32px;
                font-weight: 500;
                color: #58ABF6;
            }

            .van-picker__columns {
                .van-picker-column {
                    position: relative;
                    z-index: 3;
                }
            }

            .van-hairline-unset--top-bottom.van-picker__frame {
                color: #ffffff;
                background: #D8EFFD;
                z-index: 0;
                left: 0;
                right: 0;
            }
        }
    }
}

.there-are-teams {
    background: linear-gradient(180deg, #00236d 0%, #001d46 100%);

    .header-image {
        display: block;
        width: 100%;
    }

    .card {
        position: relative;
        padding: 0 64px;
        margin-top: -80px;

        .card-li {
            padding: 24px 0;
            background: white;
            border-radius: 8px;
        }

        .race-schedule {
            // padding-left: 40px;
            padding-right: 24px;

            .fa {
                font-weight: 500;
                color: #58abf6;
            }

            .today {
                font-size: 28px;
                background: #E4F1FD;
                padding: 6px 40px;
                border-radius: 0px 200px 200px 0px;
            }

            .team {
                font-size: 24px;
                font-weight: 400;
                color: #323232;
                position: relative;
                left: 10px;
            }

            .see {
                font-size: 24px;
            }
        }

        .several-rounds {
            font-size: 48px;
            font-weight: 500;
            color: #323232;
            text-align: center;

            .num {
                font-size: 96px;
                color: #ed4253;
                position: relative;
                padding: 0 6px;
                top: 20px;
            }

            .enter {
                color: #ED4253;

                .arrow {
                    display: inline-block;
                    width: 30px;
                    height: 25px;
                    margin: 0 8px;
                }
            }

        }

        .time {
            text-align: center;
            font-size: 24px;
            font-weight: 400;
            color: #323232;
            padding-top: 16px;
        }
    }

    .entrance {
        padding: 40px 104px 0 104px;
        text-align: center;

        .item-app {
            .icon {
                display: block;
                width: 112px;
            }

            .name {
                font-size: 28px;
                font-weight: 400;
                color: #ffffff;
                padding-top: 8px;
            }
        }
    }

    .todays-record {
        padding: 40px 48px 0 48px;

        .tabs {
            text-align: center;
            padding: 0 60px;

            .item-tab {
                font-size: 28px;
                font-weight: 500;
                color: #b5c8e1;
                background: #00429a;
                width: 50%;
                padding: 14px 0 10px 0;

                &.active {
                    background: #0072c6;
                    color: white;
                    padding-bottom: 10px;
                    border-top-left-radius: 8px;
                    border-top-right-radius: 8px;
                }

                &.reversal {
                    position: relative;
                    bottom: -6px;
                }

                &:nth-child(1).reversal {
                    border-top-left-radius: 8px;
                }

                &:nth-child(2).reversal {
                    border-top-right-radius: 8px;
                }
            }
        }

        .record-con {
            background: #0072c6;
            border-radius: 8px;
            position: relative;
            padding: 16px;

            .li-record {
                background: white;
                border-radius: 8px;
                padding: 40px 0;

                .todays-off-day {
                    text-align: center;
                    font-size: 48px;
                    font-weight: 500;
                    color: #323232;
                }

                /** 无战队代理商 */
                .no-team {
                    text-align: center;

                    .num {
                        font-size: 48px;
                        font-weight: 600;
                        color: #323232;
                        padding-bottom: 8px;
                    }

                    .name {
                        font-size: 28px;
                        font-weight: 400;
                        color: #68707D;
                    }

                }

                /** end */
                .rank-first {
                    display: block;
                    width: 100%;
                    padding-bottom: 18px;
                    position: relative;
                    margin-top: -40px;
                }

                .fucking-great {

                    .promotion-display {
                        position: relative;
                        width: 448px;
                        margin: 0 auto;


                        .pic {
                            display: block;
                            width: 100%;
                            height: 100%;
                        }

                        .strong-box {
                            position: absolute;
                            bottom: 30px;
                            left: 50%;
                            transform: translate(-50%, 0);
                            text-align: center;

                            .strong {
                                font-size: 44px;
                                font-weight: 600;
                                color: #FFFFFF;
                            }

                            .war-zone {
                                font-size: 28px;
                                font-weight: 400;
                                color: #0061D8;
                            }
                        }

                        .group-ranking {
                            position: absolute;
                            bottom: 30px;
                            left: 50%;
                            transform: translate(-50%, 0);
                            font-size: 28px;
                            font-weight: 400;
                            color: #A17100;
                        }
                    }

                    .special-sharing {
                        text-align: center;

                        .time {
                            font-size: 24px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #323232;
                            padding: 14px 0 0 0;
                        }

                        .special {
                            background: linear-gradient(90deg, #4572F7 0%, #FF5AA8 100%);
                        }
                    }

                }

                // 助力排名
                .help-rank {
                    text-align: center;

                    .num {
                        font-size: 48px;
                        font-weight: 600;
                        color: #ED4253;
                        margin-top: 40px;

                        .icon {
                            display: block;
                            width: 38px;
                            margin-right: 16px;
                        }
                    }

                    .support {
                        font-size: 28px;
                        font-weight: 400;
                        color: #68707D;
                        padding: 20px 0 8px 0;
                    }

                    .not-yet {
                        font-size: 28px;
                        font-weight: 400;
                        color: #68707D;
                        padding-top: 16px;
                    }
                }
            }

            .title {
                text-align: center;

                .todays-time {
                    min-height: 40px;
                    font-size: 24px;
                    font-weight: 400;
                    color: #323232;

                    .calendar {
                        display: block;
                        width: 28px;
                        height: 28px;
                        margin-left: 18px;
                    }
                }

                .name {
                    font-size: 34px;
                    font-weight: 500;
                    padding-bottom: 8px;
                    color: #323232;
                }

                .small-team {
                    font-size: 28px;
                    font-weight: 400;
                    color: #619cf5;
                }
            }

            .pk-number {
                position: relative;

                &::after {
                    content: '';
                    position: absolute;
                    width: 70%;
                    height: 2px;
                    background: #DEE5F0;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }

                &::before {
                    content: '';
                    position: absolute;
                    width: 2px;
                    height: 60%;
                    background: #DEE5F0;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }

                .run {
                    text-align: center;
                    padding: 26px 0;
                    width: 50%;

                    .num {
                        font-size: 48px;
                        font-weight: 600;
                        color: #323232;

                        .num-li {
                            position: relative;

                            .tips {
                                position: absolute;
                                left: 0;
                                top: -50px;
                                min-width: 140px;
                                background: #ed4253;
                                font-size: 20px;
                                font-weight: 400;
                                color: #ffffff;
                                padding: 4px 6px;
                                // white-space: nowrap;
                                border-radius: 8px;
                            }
                        }
                    }

                    .name {
                        font-size: 28px;
                        font-weight: 400;
                        color: #68707d;
                    }
                }
            }
        }

        .sign-mvp {
            display: block;
            width: 456px;
            margin: 0 auto;
            padding-top: 32px;
        }

        .view-students {
            text-align: right;
            padding-top: 24px;
            font-size: 28px;
            font-weight: 500;
            color: #58ABF6;
        }

        .battalion {
            padding-bottom: 80px;

            &.active {
                .team-information {
                    padding-top: 20px;
                }
            }

            .team-information {
                padding: 0 16px 16px 16px;
                position: relative;

                &::after {
                    content: "";
                    width: 100%;
                    height: 14px;
                    background: linear-gradient(180deg, #4099f8 0%, #1650b1 100%);
                    border-radius: 7px;
                    position: absolute;
                    top: 10px;
                    left: 0;
                    z-index: 1;
                }

                .sub-label {
                    background: #FFDD00;
                    border-radius: 20px;
                    padding: 3px 10px;
                    font-size: 24px;
                    font-weight: 500;
                    color: #FFFFFF;
                    margin-left: 8px
                }

                .team-li {
                    background: white;
                    text-align: center;
                    border-radius: 8px;
                    padding: 24px 0;
                    position: relative;
                    z-index: 2;

                    .title {
                        font-size: 32px;
                        font-weight: 500;
                        color: #58abf6;
                        padding-bottom: 8px;
                    }

                    .single-day-trophy {
                        position: relative;
                        width: 550px;
                        height: 72px;
                        margin: 0 auto;

                        .pic {
                            width: 100%;
                            height: 100%;
                            position: absolute;
                            top: 0;
                            left: 0;
                        }

                        .most {
                            font-size: 40px;
                            font-weight: 600;
                            color: #ffffff;
                            position: relative;
                            z-index: 1;
                        }
                    }

                    .time {
                        font-size: 24px;
                        font-weight: 400;
                        color: #323232;
                        padding-top: 8px;
                    }

                    .name {
                        font-size: 48px;
                        font-weight: 600;
                        color: #323232;
                        padding-top: 24px;
                    }

                    .introduce {
                        padding-top: 16px;
                        padding-bottom: 24px;

                        .number {
                            font-size: 48px;
                            font-weight: 600;
                            color: #323232;
                        }

                        .trophy {
                            font-size: 28px;
                            font-weight: 400;
                            color: #68707d;
                        }
                    }

                }
            }
        }
    }
}

.share-btn {
    width: 312px;
    height: 64px;
    background: #58abf6;
    border-radius: 32px;
    // border: 2px solid #58ABF6;
    color: white;
    font-size: 32px;
    margin: 16px auto 0 auto;

    &.off-day {
        background: linear-gradient(90deg, #4572f7 0%, #ff5aa8 100%);
    }

    .share {
        display: block;
        width: 32px;
        height: 32px;
        margin-right: 16px;
    }
}

/** 海报样式 */
#container {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;

    // position: relative;
    .time {
        min-height: 40px;
    }

    .poster-war-report {

        .bac-pic {
            width: 100%;
        }

        .time {
            font-size: 28px;
            font-weight: 400;
            color: #FFFFFF;
        }

        // 1
        .poster-conter {
            width: 90%;
            text-align: center;
            position: absolute;
            top: 38%;
            left: 50%;
            transform: translate(-50%, 0);

            .server-center {
                display: block;
                font-size: 32px;
                font-weight: 500;
                color: #ffffff;
                margin-top: 36px;
                min-height: 36px;
            }

            .title {
                margin-top: 18px;
                font-size: 48px;
                font-weight: 500;
                color: #6dfffd;
                min-width: 588px;
                min-height: 98px;
                padding: 20px 0 12px 0;
                background: url(../../assets/images/winterGame/poster-text-bac.png)no-repeat;
                background-size: 100% 100%;
                // background: linear-gradient(270deg, rgba(0, 32, 95, 0) 0%, rgba(15, 34, 118, 0.65) 52%, rgba(0, 33, 97, 0) 100%);
                // border: 2px solid;
                // border-image: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(47, 175, 252, 1), rgba(182, 255, 242, 1), rgba(47, 175, 252, 1), rgba(255, 255, 255, 0)) 2 2;
            }

            .trophy {
                padding-top: 175px;

                .name {
                    font-size: 34px;
                    font-weight: 600;
                    color: #ffffff;
                }

                .num {
                    font-size: 80px;
                    font-weight: 600;
                    color: #6dfffd;
                }
            }


        }

        // 2
        .most-trophies {
            width: 90%;
            text-align: center;
            position: absolute;
            top: 30%;
            left: 50%;
            transform: translate(-50%, 0);

            .title {
                font-size: 34px;
                font-weight: 600;
                color: #FFFFFF;
                padding-top: 6px;
                padding-bottom: 8px;
            }

            .record {
                min-width: 300px;
                height: 268px;
                margin: 0 auto;
                background: url(../../assets/images/winterGame/poster-text-bac.png)no-repeat;
                background-size: 100% 100%;

                .name {
                    font-size: 80px;
                    font-weight: 600;
                    color: #6DFFFD;
                    padding-bottom: 4px;
                    padding-top: 16px;
                }

                .arae {
                    .exhibition {
                        padding: 0 42px;

                        .number {
                            font-size: 56px;
                            font-weight: 600;
                            color: #FFFFFF;
                        }

                        .text {
                            font-size: 32px;
                            font-weight: 400;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }

        // 3
        .excellent-team {
            width: 90%;
            text-align: center;
            position: absolute;
            top: 29%;
            left: 50%;
            transform: translate(-50%, 0);

            .title {
                font-size: 34px;
                font-weight: 600;
                color: #FFFFFF;
                padding-top: 40px;
                padding-bottom: 8px;
            }

            .record {
                min-width: 300px;
                padding: 24px 0;
                margin: 0 auto;
                min-height: 98px;
                background: url(../../assets/images/winterGame/poster-text-bac.png)no-repeat;
                background-size: 100% 100%;

                .address {
                    font-size: 32px;
                    font-weight: 500;
                    color: #FFFFFF;
                }

                .name {
                    font-size: 48px;
                    font-weight: 600;
                    color: #6DFFFD;
                    padding-bottom: 4px;
                }

                .arae {
                    .exhibition {
                        padding: 0 42px;

                        .number {
                            font-size: 56px;
                            font-weight: 600;
                            color: #FFFFFF;
                        }

                        .text {
                            font-size: 32px;
                            font-weight: 400;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }

        // 4
        .promotion {
            width: 90%;
            text-align: center;
            position: absolute;
            top: 35%;
            left: 50%;
            transform: translate(-50%, 0);

            .time {
                max-height: 55px;
            }

            .server-center {
                font-size: 32px;
                font-weight: 500;
                color: #ffffff;
                margin-top: 24px;
                min-height: 36px;
            }

            .title {
                margin-top: 18px;
                font-size: 48px;
                font-weight: 500;
                color: #6dfffd;
                min-width: 588px;
                min-height: 98px;
                padding: 32px 0;
                background: url(../../assets/images/winterGame/poster-text-bac.png)no-repeat;
                background-size: 100% 100%;
            }

            .trophy {
                padding-top: 55px;

                .name {
                    font-size: 66px;
                    font-weight: bold;
                    color: #FFFFFF;
                }

                .num {
                    font-size: 32px;
                    font-weight: 400;
                    color: #A17100;
                }
            }


        }

        // 5
        .help-with-likes {
            width: 90%;
            text-align: center;
            position: absolute;
            top: 17%;
            left: 50%;
            transform: translate(-50%, 0);

            .server-center {
                font-size: 32px;
                font-weight: 500;
                color: #ffffff;
                margin-top: 24px;
                min-height: 36px;
            }

            .battalion {
                padding-top: 640px;

                .name {
                    font-size: 34px;
                    font-weight: 600;
                    color: #FFFFFF;
                }

                .title {
                    font-size: 48px;
                    font-weight: 500;
                    color: #6dfffd;
                    padding-bottom: 16px;
                }

                .introduce {
                    font-size: 32px;
                    font-weight: 500;
                    color: #FFFFFF;
                }
            }

        }
    }

    .qr-code {
        text-align: center;
        position: absolute;
        bottom: 114px;
        left: 50%;
        transform: translate(-50%, 0);

        .code-bac {
            width: 196px;
            height: 196px;
            border-radius: 2px;
            border: 8px solid #00ffff;
            margin: 0 auto;

            .code-pic {
                display: block;
                width: 100%;
                height: 100%;
                position: relative;
                z-index: 10;
            }
        }

        .distinguish {
            font-size: 24px;
            font-weight: 400;
            color: #ffffff;
            padding-top: 14px;
        }
    }
}

.loding-icon {
    position: absolute;
    left: 45%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 40;
    width: 80px;
    height: 80px;
    animation: myfirst2 1s infinite linear;
    animation: myfirst2 1s infinite linear;
}

@keyframes myfirst2 {
    0% {
        -webkit-transform: rotate(0deg);
    }

    50% {
        -webkit-transform: rotate(180deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
    }
}
</style>
